import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  activeContainer: {
    marginTop: 5,
  },
  infoText: {
    textAlign: 'left',
    lineHeight: 16,
    marginBottom: 10,
  },
  buttonWrapper: {
    width: '79%',
  },
});
